<template>
  <div class="price-decrease-table">
    <table class="table">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.key">{{ column.label }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(category) in groupedItems" :key="category.name">
          <template v-for="(channel, channelIndex) in category.channels" :key="`${category.name}-${channel.name}`">
            <tr 
              :class="{ 
                'category-row': channelIndex === 0, 
                'channel-row': 0 < channelIndex 
              }"
            >
              <!-- カテゴリ列 - 最初のチャンネル行のみ表示 -->
              <td v-if="channelIndex === 0" :rowspan="category.channels.length">{{ category.name }}</td>
              
              <!-- 販売チャンネル列 -->
              <td>{{ channel.name }}</td>
              
              <!-- 価格範囲列 -->
              <td>
                <div v-for="(range, idx) in channel.priceRanges" :key="`price-${idx}`">
                  {{ range }}
                </div>
                <div v-if="channel.priceRanges.length === 0" class="text-muted">-</div>
              </td>
              
              <!-- 値下げ率列 -->
              <td>
                <div v-for="(rate, idx) in channel.decreaseRates" :key="`rate-${idx}`">
                  {{ rate }}
                </div>
                <div v-if="channel.decreaseRates.length === 0" class="text-muted">-</div>
              </td>
              
              <!-- 値下げスパン列 -->
              <td>
                {{ channel.decreaseSpans }}
              </td>
              
              <!-- 操作列 -->
              <td>
                <button 
                  class="btn btn-sm btn-primary" 
                  @click="$emit('edit', channel.originalData)"
                >
                  編集
                </button>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PriceDecreaseTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    }
  },
  computed: {
    groupedItems() {
      // カテゴリごとにアイテムをグループ化
      const categories = {};
      
      this.items.forEach(item => {
        const categoryName = item.originalCategory || item.category;
        
        if (!categories[categoryName]) {
          categories[categoryName] = {
            name: categoryName,
            channels: []
          };
        }
        
        categories[categoryName].channels.push({
          name: item.salesChannel,
          priceRanges: item.priceRange,
          decreaseRates: item.decreaseRate,
          decreaseSpans: item.decreaseSpan,
          originalData: {
            category: categoryName,
            channel: item.originalChannel
          }
        });
      });
      
      // オブジェクトを配列に変換
      return Object.values(categories);
    }
  }
}
</script>

<style scoped>
.price-decrease-table {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #dee2e6;
}

.table th {
  padding: 0.75rem;
  text-align: left;
  background-color: #195983;
  color: white;
  border: 1px solid #dee2e6;
  white-space: nowrap;
}

.table td {
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  vertical-align: middle;
}

.category-row td {
  border-top: 2px solid #dee2e6;
}

.channel-row td {
  border-top: 1px solid #adb5bd;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}

.text-muted {
  color: #6c757d;
}
</style>
